import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MobileBottomBar from '@/components/feature/MobileBottomBar';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main className="pt-24 md:pt-28">
        {/* Hero */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '900px' }}>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-5 text-center">
              Создаём надёжные конструкции из&nbsp;металла
            </h1>
            <p className="text-sm md:text-base text-foreground-600 text-center max-w-2xl mx-auto leading-relaxed">
              «Художественная ковка» — мастерская металла с&nbsp;собственным производством. Более 10&nbsp;лет изготавливаем навесы, беседки, ворота, мангальные зоны и&nbsp;кованые изделия для&nbsp;частных домов в&nbsp;Приютово, Белебее, Ермекеево, Бижбуляке, Абдулино, Пономарёвке, Матвеевке, Новомихайловке, Бавлах, Бугуруслане, Киргиз-Мияках, Туймазах, Октябрьском, Буздяке, Кандрах, Давлеканово, Раевке, Уфе и&nbsp;Чишмах.
            </p>
          </div>
        </section>

        {/* Approach */}
        <section className="py-14 md:py-18 bg-background-100">
          <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1200px' }}>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-10 text-center">
              Наш подход
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {[
                { icon: 'ri-focus-3-line', title: 'Точность', desc: 'Каждый проект начинается с&nbsp;точного замера и&nbsp;проектирования. Учитываем рельеф, грунт, нагрузки и&nbsp;ваши пожелания.' },
                { icon: 'ri-shield-flash-line', title: 'Прочность', desc: 'Используем качественный металл, усиленные узлы и&nbsp;проверенные технологии сварки. Конструкции служат десятилетиями.' },
                { icon: 'ri-building-line', title: 'Аккуратный монтаж', desc: 'Работаем чисто и&nbsp;бережно. После монтажа убираем строительный мусор, не&nbsp;повреждаем покрытие участка.' },
                { icon: 'ri-calendar-check-line', title: 'Соблюдение сроков', desc: 'Фиксируем даты в&nbsp;договоре. Предупреждаем о&nbsp;каждом этапе заранее. Сдаём объекты вовремя.' },
              ].map((item) => (
                <div key={item.title} className="bg-background-50 border border-background-200/60 rounded-lg p-6 md:p-7 flex gap-4">
                  <div className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 shrink-0">
                    <i className={`${item.icon} text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-1.5">{item.title}</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: item.desc }}></p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Guarantees */}
        <section className="py-14 md:py-18 bg-background-50">
          <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1200px' }}>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-10 text-center">
              Гарантии
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              {[
                { icon: 'ri-file-text-line', title: 'Договор', desc: 'Работаем официально с&nbsp;заключением договора. Все условия зафиксированы на&nbsp;бумаге.' },
                { icon: 'ri-coins-line', title: 'Прозрачная смета', desc: 'Фиксированная цена без&nbsp;скрытых платежей. Вы&nbsp;знаете, за&nbsp;что платите.' },
                { icon: 'ri-shield-check-line', title: 'Гарантия', desc: 'Гарантия на&nbsp;каркас и&nbsp;монтаж. Уверены в&nbsp;качестве своей работы.' },
              ].map((item) => (
                <div key={item.title} className="text-center bg-background-100 border border-background-200/60 rounded-lg p-6 md:p-7">
                  <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
                    <i className={`${item.icon} text-2xl`}></i>
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: item.desc }}></p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-14 md:py-18 bg-background-100">
          <div className="mx-auto px-4 md:px-6 text-center" style={{ maxWidth: '700px' }}>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              Готовы обсудить ваш проект?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-7">
              Оставьте заявку — расскажем о&nbsp;сроках, стоимости и&nbsp;ответим на&nbsp;все вопросы.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 flex-wrap">
              <Link to="/#cta-form" className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-base px-8 py-3.5 rounded-md transition-all duration-300 cursor-pointer">
                Рассчитать стоимость
              </Link>
              <a href="tel:+79174131562" className="whitespace-nowrap border-2 border-foreground-200 hover:border-primary-400 text-foreground-800 font-semibold text-base px-8 py-3.5 rounded-md transition-all duration-300 cursor-pointer">
                Позвонить
              </a>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-3 mt-6">
              <a href="https://wa.me/79174131562" target="_blank" rel="noopener noreferrer" className="whitespace-nowrap flex items-center gap-2 bg-[#25D366] hover:bg-[#1eb851] text-background-50 font-medium text-sm px-5 py-2.5 rounded-md transition-all duration-300 cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-whatsapp-line text-lg"></i></span> WhatsApp
              </a>
              <a href="https://max.ru/u/f9LHodD0cOICoHyOC2LT2Vx_42oC8Zdm2VV9Uv5O-6mGvkZgeZzUcJQkER0" target="_blank" rel="noopener noreferrer" className="whitespace-nowrap flex items-center gap-2 bg-accent-600 hover:bg-accent-700 text-background-50 font-medium text-sm px-5 py-2.5 rounded-md transition-all duration-300 cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-chat-3-line text-lg"></i></span> MAX
              </a>
              <a href="https://t.me/Gmgmg0202" target="_blank" rel="noopener noreferrer" className="whitespace-nowrap flex items-center gap-2 bg-[#2AABEE] hover:bg-[#2299d6] text-background-50 font-medium text-sm px-5 py-2.5 rounded-md transition-all duration-300 cursor-pointer">
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-telegram-line text-lg"></i></span> Telegram
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <MobileBottomBar />
    </>
  );
}